﻿(function () {
  const roots = document.querySelectorAll("[data-zoda-quiz]");
  if (!roots.length) return;

  const totalFlowSteps = 8;
  const productImages = {
    sprintzSingletF: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/pulsecollection-21.jpg?v=1753996919",
    sprintzSingletM: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/pulsecollection-7.jpg?v=1753822516",
    sprintzShortsF: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/pulsecollection-33.jpg?v=1753858773",
    sprintzShortsM: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/pulsecollection-4.jpg?v=1753996682",
    moveBra: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/move_sports_bra_-_04.jpg?v=1750054571",
    moveShorts35: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/move_high_rise_shorts_-_02.jpg?v=1750215280",
    moveShorts9: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/highrisebikeshorts-02.jpg?v=1750054332",
    performTankM: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/ZodaPerfromTank-35.jpg?v=1774470221",
    performTankF: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/Zoda_Perfrom_Tank-58.jpg?v=1782293321",
    performTeeM: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/zoda_men.jpg?v=1729726889",
    performTeeF: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/04._Zoda_Grey_Tee_F_02.jpg?v=1758046767",
    performBra: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/01._Zoda_Green_Sports_Bra_01.jpg?v=1758046995",
    performShortsF: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/Women_sShorts_1.webp?v=1746449216",
    performShortsM: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/MenShorts_2.webp?v=1746446775",
    performShortsM7: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/07._Zoda_Black_Shorts_01.jpg?v=1758042207",
    conquerBra: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/g3_sports_bra_-_04.jpg?v=1750146954",
    conquerTights: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/high_rise_leggings_-_06.jpg?v=1750054783",
    nfcTee: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/Unisex_Oversized_Tee_with_NFC_Cover.png?v=1746448206",
    nfcCroppedTee: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/ZODACroppedTop-BeastMode_6.webp?v=1741673470",
    carbonTee: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/Unisex_Oversized_Tee_Cover.png?v=1746447782",
    carbonCroppedTee: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/ZODACroppedTop-BurntOrange_3.webp?v=1741336696",
    sweatband: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/zoda_sweatband_-_05.jpg?v=1750215838",
    headband: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/headbands-01.jpg?v=1766151521",
    scrunchies: "https://cdn.shopify.com/s/files/1/0893/5224/1442/files/zodascrunchies-02.jpg?v=1750173080"
  };

  const accessoryImages = {
    Sweatband: productImages.sweatband,
    Headband: productImages.headband,
    Scrunchies: productImages.scrunchies
  };

  const accessoryHandles = {
    Sweatband: "unisex-sweatband",
    Headband: "headband-unisex",
    Scrunchies: "scrunchies-f"
  };

  const answerIcons = {
    women: "bra",
    men: "tank",
    unisex: "tee",
    "running-hiit": "bolt",
    strength: "weight",
    hybrid: "switch",
    everyday: "sun",
    mixed: "shuffle",
    "w-35": "shorts",
    "w-9": "shorts-long",
    "w-tights": "tights",
    "m-5": "shorts",
    "m-6": "shorts",
    "m-7": "shorts-long",
    any: "tee",
    "sports-bra": "bra",
    "w-tank": "tank",
    "w-tee": "tee",
    singlet: "singlet",
    "m-tank": "tank",
    "m-tee": "tee",
    oversized: "tee-wide",
    cropped: "tee-crop",
    structure: "grid",
    breathable: "air",
    support: "shield",
    matching: "set",
    none: "dash",
    Sweatband: "band",
    Headband: "headband",
    Scrunchies: "scrunchie"
  };

  const bottomOptions = {
    "w-35": {
      label: "MOVE High-Rise Shorts 3.5\"",
      image: productImages.moveShorts35,
      handle: "high-rise-move-shorts-3-5-women-of-strength-collection"
    },
    "w-9": {
      label: "MOVE High-Rise 9\" Bike Shorts",
      image: productImages.moveShorts9,
      handle: "move-high-rise-shorts-9"
    },
    "w-tights": {
      label: "CONQUER High-Rise Tights",
      image: productImages.conquerTights,
      handle: "conquer-high-rise-ankle-length"
    },
    "m-5": {
      label: "Men's Sprintz Shorts 5\"",
      image: productImages.sprintzShortsM,
      handle: "sprintz-shorts-5-m"
    },
    "m-6": {
      label: "Perform Shorts M 6\"",
      image: productImages.performShortsM,
      handle: "perform-shorts-m-6"
    },
    "m-7": {
      label: "Perform Shorts M 7\"",
      image: productImages.performShortsM7,
      handle: "perform-shorts-m-7"
    }
  };

  const topOptions = {
    "w-tank": {
      label: "Perform Tank F",
      image: productImages.performTankF,
      handle: "perform-tank-f"
    },
    "w-tee": {
      label: "Perform Tee F",
      image: productImages.performTeeF,
      handle: "perform-tee-f"
    },
    singlet: {
      label: "Men's Sprintz Singlet",
      image: productImages.sprintzSingletM,
      handle: "sprintz-singlet-m"
    },
    "m-tank": {
      label: "Perform Tank M",
      image: productImages.performTankM,
      handle: "perform-tank-m"
    },
    "m-tee": {
      label: "Perform Tee M",
      image: productImages.performTeeM,
      handle: "perform-tee-m"
    },
    oversized: {
      label: "Oversized Tee",
      signalImage: productImages.nfcTee,
      signalHandle: "nfc-oversized-tee",
      lightformImage: productImages.carbonTee,
      lightformHandle: "unisex-oversized-tee-with-carbon-capture"
    },
    cropped: {
      label: "Cropped Tee",
      signalImage: productImages.nfcCroppedTee,
      signalHandle: "nfc-cropped-tee-beast-mode",
      lightformImage: productImages.carbonCroppedTee,
      lightformHandle: "carbon-capture-cropped-tee"
    }
  };

  const outcomeData = {
    speed: {
      title: "The Speed Mode Set",
      collection: "Women's Sprintz Collection",
      copy: "For athletes who move fast and want gear that keeps up.",
      top: "Women's Sprintz Singlet or MOVE Sports Bra",
      bottom: "Women's Sprintz Shorts 3.5\"",
      accessories: ["Scrunchies", "Sweatband", "Headband"],
      url: "/products/sprintz-shorts-3-5-f",
      topHandle: "sprintz-singlet-f",
      bottomHandle: "sprintz-shorts-3-5-f",
      topImage: productImages.sprintzSingletF,
      bottomImage: productImages.sprintzShortsF
    },
    lightair: {
      title: "The Light as Air Set",
      collection: "Men's Sprintz Collection",
      copy: "Zero drag. Maximum airflow.",
      top: "Men's Sprintz Singlet",
      bottom: "Men's Sprintz Shorts 5\"",
      accessories: ["Sweatband", "Headband"],
      url: "/products/sprintz-shorts-5-m",
      topHandle: "sprintz-singlet-m",
      bottomHandle: "sprintz-shorts-5-m",
      topImage: productImages.sprintzSingletM,
      bottomImage: productImages.sprintzShortsM
    },
    everyday: {
      title: "The Everyday Driver",
      collection: "Women's Move 3.5\"",
      copy: "Effortless, comfortable and daily training approved.",
      top: "MOVE Sports Bra or MOVE Tee",
      bottom: "MOVE High-Rise Shorts 3.5\"",
      accessories: ["Headband", "Scrunchies"],
      url: "/products/high-rise-move-shorts-3-5-women-of-strength-collection",
      topHandle: "move-bra",
      bottomHandle: "high-rise-move-shorts-3-5-women-of-strength-collection",
      topImage: productImages.moveBra,
      bottomImage: productImages.moveShorts35
    },
    stayready: {
      title: "The Stay-Ready Set",
      collection: "Women's Move 9\"",
      copy: "A smooth, locked-in silhouette for warmups, cooldowns and everything between.",
      top: "MOVE Sports Bra or MOVE Tank",
      bottom: "MOVE High-Rise 9\" Bike Shorts",
      accessories: ["Scrunchies"],
      url: "/products/move-high-rise-shorts-9",
      topHandle: "move-bra",
      bottomHandle: "move-high-rise-shorts-9",
      topImage: productImages.moveBra,
      bottomImage: productImages.moveShorts9
    },
    control: {
      title: "The Control Set",
      collection: "Men's Perform 6\"",
      copy: "Structured, durable pieces for clean reps and focused training.",
      top: "Men's Perform Tank with Carbon Capture",
      bottom: "Perform Shorts M 6\"",
      accessories: ["Sweatband"],
      url: "/products/perform-shorts-m-6",
      topHandle: "perform-tank-m",
      bottomHandle: "perform-shorts-m-6",
      topImage: productImages.performTankM,
      bottomImage: productImages.performShortsM
    },
    grind: {
      title: "The Grind + Flow Set",
      collection: "Men's Perform 7\"",
      copy: "Coverage and comfort built for longer sessions.",
      top: "Men's Perform Tee",
      bottom: "Perform Shorts M 7\"",
      accessories: ["Headband"],
      url: "/collections/core-performance",
      topHandle: "perform-tee-m",
      bottomHandle: "perform-shorts-m-7",
      topImage: productImages.performTeeM,
      bottomImage: productImages.performShortsM7
    },
    lockin: {
      title: "The Lock-In Set",
      collection: "Women's Conquer",
      copy: "High support and full stability for demanding training.",
      top: "CONQUER Sports Bra",
      bottom: "CONQUER High-Rise Tights",
      accessories: ["Headband"],
      url: "/products/conquer-high-rise-ankle-length",
      topHandle: "conquer-bra",
      bottomHandle: "conquer-high-rise-ankle-length",
      topImage: productImages.conquerBra,
      bottomImage: productImages.conquerTights
    },
    precision: {
      title: "The Precision Set",
      collection: "Women's Perform",
      copy: "A structured, performance-first set for strength and conditioning.",
      top: "Perform Racerback Sports Bra",
      bottom: "Perform Shorts F 5\" or Women's Perform High-Rise Tights",
      accessories: ["Scrunchies"],
      url: "/products/perform-shorts-f-5",
      topHandle: "perform-bra",
      bottomHandle: "perform-shorts-f-5",
      topImage: productImages.performBra,
      bottomImage: productImages.performShortsF
    },
    signal: {
      title: "The Signal Set",
      collection: "NFC Collection",
      copy: "Clean lines, modern structure and NFC-enabled tech.",
      top: "Oversized Tee with NFC or Cropped Tee with NFC",
      bottom: "Your selected Sprintz, Move or Perform bottom",
      accessories: ["Sweatband", "Headband"],
      url: "/products/nfc-oversized-tee",
      topHandle: "nfc-oversized-tee",
      bottomHandle: "",
      topImage: productImages.nfcTee,
      bottomImage: productImages.nfcTee
    },
    lightform: {
      title: "The Lightform Set",
      collection: "Carbon Capture Collection",
      copy: "Airy, breathable fabrics with a clean, easy silhouette.",
      top: "Carbon Capture tee or Perform Tank with Carbon Capture",
      bottom: "Your selected Sprintz, Move or Perform bottom",
      accessories: [],
      url: "/products/unisex-oversized-tee-with-carbon-capture",
      topHandle: "unisex-oversized-tee-with-carbon-capture",
      bottomHandle: "",
      topImage: productImages.carbonTee,
      bottomImage: productImages.carbonTee
    }
  };

  const routeRoot = window.Shopify?.routes?.root || "/";
  const shopifyRoute = (path) => `${routeRoot.replace(/\/?$/, "/")}${path.replace(/^\//, "")}`;
  const productCache = new Map();

  const getNativeApp = () => {
    const doc = document.documentElement;
    try {
      return window.Alpine?.$data?.(doc) || doc._x_dataStack?.[0] || null;
    } catch {
      return doc._x_dataStack?.[0] || null;
    }
  };

  const openNativeCart = () => {
    const app = getNativeApp();
    if (!app) return false;
    if (typeof app.openCart === "function") {
      app.openCart();
    } else {
      app.cart_drawer = true;
      app.cart_alert = false;
      app.enable_body_scrolling = false;
      app.has_overlay = true;
    }
    return true;
  };

  const refreshNativeCart = async () => {
    const app = getNativeApp();
    if (typeof app?.updateCart === "function") {
      await app.updateCart(false);
    }
    openNativeCart();
  };

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    const response = await fetch(shopifyRoute(`products/${handle}.js`), {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error(`Could not load ${handle}`);
    const product = await response.json();
    productCache.set(handle, product);
    return product;
  }

  roots.forEach((root) => {
    const allSteps = Array.from(root.querySelectorAll("[data-zoda-quiz-step]"));
    const resultPanel = root.querySelector("[data-zoda-quiz-result]");
    const resultTitle = root.querySelector("[data-zoda-quiz-result-title]");
    const resultCopy = root.querySelector("[data-zoda-quiz-result-copy]");
    const resultTop = root.querySelector("[data-zoda-quiz-result-top]");
    const resultBottom = root.querySelector("[data-zoda-quiz-result-bottom]");
    const resultAccessory = root.querySelector("[data-zoda-quiz-result-accessory]");
    const resultTopImage = root.querySelector("[data-zoda-quiz-result-top-image]");
    const resultBottomImage = root.querySelector("[data-zoda-quiz-result-bottom-image]");
    const resultAccessoryImage = root.querySelector("[data-zoda-quiz-result-accessory-image]");
    const resultReasons = root.querySelector("[data-zoda-quiz-result-reasons]");
    const resultLink = root.querySelector("[data-zoda-quiz-result-link]");
    const progress = root.querySelector("[data-zoda-quiz-progress]");
    const count = root.querySelector("[data-zoda-quiz-count]");
    const quizImage = root.querySelector("[data-zoda-quiz-image]");
    const storyKicker = root.querySelector("[data-zoda-quiz-story-kicker]");
    const storyTitle = root.querySelector("[data-zoda-quiz-story-title]");
    const storyCopy = root.querySelector("[data-zoda-quiz-story-copy]");
    const controls = root.querySelector(".zoda-quiz__controls");
    const backButton = root.querySelector("[data-zoda-quiz-back]");
    const nextButton = root.querySelector("[data-zoda-quiz-next]");
    const restartButtons = root.querySelectorAll("[data-zoda-quiz-restart]");
    const form = root.querySelector("[data-zoda-quiz-email-form]");
    const emailInput = root.querySelector("[data-zoda-quiz-email]");
    const variantModal = root.querySelector("[data-zoda-quiz-variant-modal]");
    const variantPicker = root.querySelector("[data-zoda-quiz-variant-picker]");
    const variantClose = root.querySelector("[data-zoda-quiz-variant-close]");
    const addSetButton = root.querySelector("[data-zoda-quiz-add-set]");
    const variantNote = root.querySelector("[data-zoda-quiz-variant-note]");
    const shopLink = root.querySelector("[data-zoda-quiz-shop-link]");

    const state = {
      activeIndex: 0,
      answers: {},
      selections: new Map(),
      resultUrl: "/collections/all",
      winnerKey: "",
      winner: null,
      modalItems: []
    };

    trackEvent("zoda_quiz_started", {
      quiz_name: "zoda_outfit_builder"
    });

    function getGender() {
      return state.answers.gender || "";
    }

    function getVisibleSteps() {
      const gender = getGender();
      return allSteps.filter((step) => {
        const requiredGender = step.getAttribute("data-show-step-for");
        return !requiredGender || requiredGender === gender;
      });
    }

    function updateConditionalAnswers() {
      const gender = getGender();
      root.querySelectorAll("[data-show-for]").forEach((answer) => {
        const allowed = answer.getAttribute("data-show-for").split(",").map((item) => item.trim());
        const shouldShow = !gender || allowed.includes(gender);
        answer.hidden = !shouldShow;
        if (!shouldShow && answer.classList.contains("is-selected")) {
          answer.classList.remove("is-selected");
        }
      });

      allSteps.forEach((step) => {
        const answers = step.querySelector(".zoda-quiz__answers");
        if (!answers) return;
        const visibleCount = Array.from(answers.querySelectorAll("[data-zoda-quiz-answer]"))
          .filter((answer) => !answer.hidden).length;
        answers.dataset.visibleCount = String(visibleCount);
      });
    }

    function updateImage(nextImage) {
      if (!quizImage || !nextImage || quizImage.getAttribute("src") === nextImage) return;
      quizImage.classList.add("is-changing");
      window.setTimeout(() => {
        quizImage.setAttribute("src", nextImage);
        quizImage.classList.remove("is-changing");
      }, 140);
    }

    function updateStory(kicker, title, copy) {
      if (storyKicker && kicker) storyKicker.textContent = kicker;
      if (storyTitle && title) storyTitle.textContent = title;
      if (storyCopy && copy) storyCopy.textContent = copy;
    }

    function answerIconMarkup(type) {
      const icons = {
        air: '<path d="M5 9h14M7 14h10M10 19h7"/>',
        band: '<rect x="6" y="8" width="12" height="8" rx="2"/><path d="M8 8V6h8v2M8 16v2h8v-2"/>',
        bolt: '<path d="M13 2 5 14h6l-1 8 9-13h-6l1-7Z"/>',
        bra: '<path d="M7 9c0-2 1.5-4 4-4h2c2.5 0 4 2 4 4v8H7V9Z"/><path d="M12 5v12M7 12h10"/>',
        grid: '<path d="M4 6h16M4 12h16M4 18h16M8 4v16M16 4v16"/>',
        headband: '<path d="M5 13a7 7 0 0 1 14 0v3H5v-3Z"/><path d="M8 16v3h8v-3"/>',
        scrunchie: '<path d="M12 5c4 0 7 3 7 7s-3 7-7 7-7-3-7-7 3-7 7-7Z"/><path d="M12 9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3Z"/>',
        set: '<path d="M7 5h5v14H7zM14 7h4v10h-4z"/>',
        shield: '<path d="M12 3 19 6v5c0 4.5-3 7.8-7 10-4-2.2-7-5.5-7-10V6l7-3Z"/>',
        shorts: '<path d="M7 5h10l1 14h-5l-1-6-1 6H6L7 5Z"/><path d="M7 9h10"/>',
        "shorts-long": '<path d="M7 5h10l1 16h-5l-1-8-1 8H6L7 5Z"/><path d="M7 9h10"/>',
        shuffle: '<path d="M4 7h4l8 10h4M16 7h4v4M4 17h4l2-2M16 17h4v-4"/>',
        singlet: '<path d="M9 4h6l2 4-2 3v8H9v-8L7 8l2-4Z"/><path d="M10 4c0 2 4 2 4 0"/>',
        sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M19.8 4.2l-2.1 2.1M6.3 17.7l-2.1 2.1"/>',
        tank: '<path d="M8 4h8l2 5-2 2v8H8v-8L6 9l2-5Z"/><path d="M10 4v5h4V4"/>',
        tee: '<path d="M8 5h8l4 4-3 3-1-1v8H8v-8l-1 1-3-3 4-4Z"/>',
        "tee-crop": '<path d="M8 5h8l4 4-3 3-1-1v6H8v-6l-1 1-3-3 4-4Z"/>',
        "tee-wide": '<path d="M7 6h10l5 4-3 4-2-1v6H7v-6l-2 1-3-4 5-4Z"/>',
        tights: '<path d="M8 4h8l1 17h-5l-.5-8-.5 8H6L8 4Z"/><path d="M8 8h8"/>',
        weight: '<path d="M4 10v4M7 8v8M17 8v8M20 10v4M7 12h10"/>',
        switch: '<path d="M7 7h10M14 4l3 3-3 3M17 17H7M10 14l-3 3 3 3"/>',
        dash: '<path d="M7 12h10"/><path d="M12 7v10" opacity=".35"/>'
      };
      return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${icons[type] || icons.tee}</svg>`;
    }

    function decorateAnswerIcons() {
      root.querySelectorAll("[data-zoda-quiz-answer]").forEach((answer) => {
        if (answer.querySelector(".zoda-quiz__answer-media")) return;
        const value = answer.getAttribute("data-value") || "";
        const icon = answerIcons[value];
        const step = answer.closest("[data-zoda-quiz-step]");
        const isSizeStep = step?.getAttribute("data-step-key") === "size";
        if (!icon || isSizeStep) return;
        const media = document.createElement("span");
        media.className = "zoda-quiz__answer-media";
        media.innerHTML = answerIconMarkup(icon);
        answer.prepend(media);
      });
    }

    function activeSteps() {
      return getVisibleSteps();
    }

    function currentStep() {
      return activeSteps()[state.activeIndex];
    }

    function currentStepKey() {
      const step = currentStep();
      return step ? step.getAttribute("data-step-key") : "";
    }

    function render() {
      updateConditionalAnswers();
      const steps = activeSteps();
      allSteps.forEach((step) => {
        step.classList.toggle("is-active", step === steps[state.activeIndex]);
        const key = step.getAttribute("data-step-key");
        step.querySelectorAll("[data-zoda-quiz-answer]").forEach((answer) => {
          answer.classList.toggle("is-selected", state.selections.get(key) === answer);
        });
      });

      const activeStep = currentStep();
      if (activeStep) {
        const question = activeStep.querySelector(".zoda-quiz__question");
        const help = activeStep.querySelector(".zoda-quiz__help");
        updateImage(activeStep.getAttribute("data-image"));
        updateStory(
          `Outfit builder ${String(state.activeIndex + 1).padStart(2, "0")} / ${String(totalFlowSteps).padStart(2, "0")}`,
          question && question.textContent,
          help && help.textContent
        );
      }

      if (resultPanel) resultPanel.classList.remove("is-active");
      if (controls) controls.hidden = false;
      if (progress) progress.style.width = `${Math.round(((state.activeIndex + 1) / steps.length) * 100)}%`;
      if (count) count.textContent = `${String(state.activeIndex + 1).padStart(2, "0")} / ${String(totalFlowSteps).padStart(2, "0")}`;
      if (backButton) backButton.hidden = state.activeIndex === 0;
      if (nextButton) {
        nextButton.hidden = false;
        nextButton.disabled = !state.selections.get(currentStepKey());
      }
    }

    function getWinner() {
      const gender = getGender();
      const training = state.answers.training;
      const bottom = state.answers.bottom;
      const top = state.answers.top;
      const gear = state.answers.gear;
      const support = state.answers.support;

      if (gear === "structure") return "signal";
      if (gear === "breathable") return "lightform";

      if (gender === "unisex") return top === "oversized" ? "signal" : "lightform";

      if (gender === "men") {
        if (bottom === "m-5" || top === "singlet" || training === "running-hiit") return "lightair";
        if (bottom === "m-7" || top === "m-tee") return "grind";
        return "control";
      }

      if (gender === "women") {
        if (support === "high" || bottom === "w-tights") return support === "high" ? "lockin" : "precision";
        if (support === "light") return "precision";
        if (bottom === "w-9") return "stayready";
        if (top === "w-tee" || training === "everyday") return "everyday";
        if (training === "hybrid" || training === "strength") return "precision";
        return "speed";
      }

      return "speed";
    }

    function selectedAccessory(fallbacks) {
      const accessory = state.answers.accessory;
      if (accessory === "None") return "No accessory";
      if (accessory && accessoryImages[accessory]) return accessory;
      return fallbacks.length ? fallbacks.join(", ") : "No accessory";
    }

    function selectedAccessoryImage(winner) {
      const accessory = state.answers.accessory;
      if (accessory === "None") return "";
      if (accessory && accessoryImages[accessory]) return accessoryImages[accessory];
      const fallback = winner.accessories.find((item) => accessoryImages[item]);
      return fallback ? accessoryImages[fallback] : "";
    }

    function selectedTop(winnerKey, winner) {
      const top = state.answers.top;
      if (top === "sports-bra") {
        if (winnerKey === "lockin") return "CONQUER Sports Bra";
        if (winnerKey === "precision") return "Perform Bra";
        return "MOVE Bra";
      }
      const option = topOptions[top];
      return option ? option.label : winner.top;
    }

    function selectedTopImage(winnerKey, winner) {
      const top = state.answers.top;
      if (top === "sports-bra") {
        if (winnerKey === "lockin") return productImages.conquerBra;
        if (winnerKey === "precision") return productImages.performBra;
        return productImages.moveBra;
      }
      const option = topOptions[top];
      if (!option) return winner.topImage;
      if (winnerKey === "signal" && option.signalImage) return option.signalImage;
      if (winnerKey === "lightform" && option.lightformImage) return option.lightformImage;
      return option.image || winner.topImage;
    }

    function selectedTopHandle(winnerKey, winner) {
      const top = state.answers.top;
      if (top === "sports-bra") {
        if (winnerKey === "lockin") return "conquer-bra";
        if (winnerKey === "precision") return "perform-bra";
        return "move-bra";
      }
      const option = topOptions[top];
      if (!option) return winner.topHandle || "";
      if (winnerKey === "signal" && option.signalHandle) return option.signalHandle;
      if (winnerKey === "lightform" && option.lightformHandle) return option.lightformHandle;
      return option.handle || winner.topHandle || "";
    }

    function selectedBottom(winner) {
      const bottom = bottomOptions[state.answers.bottom];
      if (bottom) return bottom.label;
      if (state.answers.bottom === "any" || state.answers.bottom === "none") return "No bottom selected";
      return winner.bottom;
    }

    function selectedBottomImage(winner) {
      const bottom = bottomOptions[state.answers.bottom];
      if (state.answers.bottom === "any" || state.answers.bottom === "none") return "";
      return bottom ? bottom.image : winner.bottomImage;
    }

    function selectedBottomHandle(winner) {
      const bottom = bottomOptions[state.answers.bottom];
      if (state.answers.bottom === "any" || state.answers.bottom === "none") return "";
      return bottom?.handle || winner.bottomHandle || "";
    }

    function selectedAccessoryHandle(winner) {
      const accessory = state.answers.accessory;
      if (accessory === "None") return "";
      if (accessory && accessoryHandles[accessory]) return accessoryHandles[accessory];
      const fallback = winner.accessories.find((item) => accessoryHandles[item]);
      return fallback ? accessoryHandles[fallback] : "";
    }

    function buildModalProducts(winnerKey, winner) {
      const products = [];
      const topHandle = selectedTopHandle(winnerKey, winner);
      const bottomHandle = selectedBottomHandle(winner);
      const accessoryHandle = selectedAccessoryHandle(winner);
      if (topHandle) products.push({ role: "Top", handle: topHandle });
      if (bottomHandle && bottomHandle !== topHandle) products.push({ role: "Bottom", handle: bottomHandle });
      if (accessoryHandle) products.push({ role: "Accessory", handle: accessoryHandle });
      return products;
    }

    function variantTitle(variant) {
      return (variant.public_title || variant.title || "Default").replace(/^Default Title$/i, "One size");
    }

    function renderVariantItem(product, role) {
      const availableVariants = product.variants.filter((variant) => variant.available);
      const variants = availableVariants.length ? availableVariants : product.variants;
      const first = variants[0];
      const item = document.createElement("article");
      item.className = "zoda-quiz__variant-item";
      item.dataset.productHandle = product.handle;
      item.innerHTML = `
        <img class="zoda-quiz__variant-image" src="${product.featured_image || ""}" alt="">
        <div class="zoda-quiz__variant-copy">
          <p>${role}</p>
          <h3>${product.title}</h3>
          <label>
            <span>Size / color</span>
            <select data-zoda-quiz-variant-select></select>
          </label>
        </div>
      `;
      const select = item.querySelector("[data-zoda-quiz-variant-select]");
      variants.forEach((variant) => {
        const option = document.createElement("option");
        option.value = variant.id;
        option.textContent = variant.available ? variantTitle(variant) : `${variantTitle(variant)} - sold out`;
        option.disabled = !variant.available;
        select.appendChild(option);
      });
      if (first) select.value = String(first.id);
      return item;
    }

    async function prepareVariantModal() {
      if (!variantPicker) return;
      variantPicker.innerHTML = '<p class="zoda-quiz__variant-loading">Loading available options...</p>';
      if (variantNote) variantNote.textContent = "";
      const winnerKey = state.winnerKey || getWinner();
      const winner = state.winner || outcomeData[winnerKey] || outcomeData.speed;
      const modalProducts = buildModalProducts(winnerKey, winner);
      try {
        const products = (await Promise.all(modalProducts.map((item) => fetchProduct(item.handle)
          .then((product) => product ? { ...item, product } : null)
          .catch(() => null)))).filter(Boolean);
        variantPicker.innerHTML = "";
        state.modalItems = products;
        products.forEach((item) => variantPicker.appendChild(renderVariantItem(item.product, item.role)));
        if (!products.length && variantNote) variantNote.textContent = "No available matched products found. You can still shop the full collection.";
      } catch {
        variantPicker.innerHTML = "";
        if (variantNote) variantNote.textContent = "Options could not load right now. Please shop the match instead.";
      }
    }

    function openVariantModal() {
      if (!variantModal) return;
      variantModal.hidden = false;
      document.documentElement.classList.add("zoda-quiz-modal-open");
      prepareVariantModal();
      variantClose?.focus();
    }

    function closeVariantModal() {
      if (!variantModal) return;
      variantModal.hidden = true;
      document.documentElement.classList.remove("zoda-quiz-modal-open");
      resultLink?.focus();
    }

    async function addSelectedSet() {
      if (!variantPicker || !addSetButton) return;
      const ids = Array.from(variantPicker.querySelectorAll("[data-zoda-quiz-variant-select]"))
        .map((select) => Number(select.value))
        .filter((id) => Number.isFinite(id) && id > 0);
      if (!ids.length) {
        if (variantNote) variantNote.textContent = "Please choose at least one available option.";
        return;
      }
      addSetButton.disabled = true;
      addSetButton.textContent = "Adding...";
      try {
        const response = await fetch(shopifyRoute("cart/add.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
        });
        if (!response.ok) throw new Error("Cart add failed");
        addSetButton.textContent = "Added";
        closeVariantModal();
        await refreshNativeCart();
      } catch {
        addSetButton.textContent = "Try again";
        if (variantNote) variantNote.textContent = "One of the selected variants could not be added. Choose another option or shop the match.";
      } finally {
        window.setTimeout(() => {
          addSetButton.disabled = false;
          addSetButton.textContent = "Add selected set";
        }, 1200);
      }
    }

    function answerLabel(key) {
      const answer = state.selections.get(key);
      if (!answer) return "";
      const label = answer.querySelector("span:not(.zoda-quiz__answer-media)");
      return label ? label.childNodes[0].textContent.trim() : "";
    }

    function buildReasons() {
      const reasons = [];
      const training = answerLabel("training");
      const bottom = answerLabel("bottom");
      const top = answerLabel("top");
      const gear = answerLabel("gear");
      if (training) reasons.push(`Training style: ${training}`);
      if (bottom && bottom !== "No strong preference") reasons.push(`Bottom preference: ${bottom}`);
      if (top && top !== "No preference") reasons.push(`Top preference: ${top}`);
      if (gear) reasons.push(`Gear feel: ${gear}`);
      return reasons.slice(0, 3).filter(Boolean);
    }

    function setResultImage(image, src, alt) {
      if (!image) return;
      if (!src) {
        image.removeAttribute("src");
        image.alt = "";
        image.hidden = true;
        image.closest(".zoda-quiz__result-card")?.classList.add("zoda-quiz__result-card--text-only");
        return;
      }
      image.src = src;
      image.alt = alt || "";
      image.hidden = false;
      image.closest(".zoda-quiz__result-card")?.classList.remove("zoda-quiz__result-card--text-only");
    }

    function trackEvent(name, params) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
      if (typeof window.gtag === "function") window.gtag("event", name, params);
    }

    function showResult() {
      const winnerKey = getWinner();
      const winner = outcomeData[winnerKey] || outcomeData.speed;
      state.resultUrl = winner.url || "/collections/all";
      state.winnerKey = winnerKey;
      state.winner = winner;
      allSteps.forEach((step) => step.classList.remove("is-active"));
      if (progress) progress.style.width = "100%";
      if (count) count.textContent = "Result";
      if (backButton) backButton.hidden = true;
      if (nextButton) nextButton.hidden = true;
      if (controls) controls.hidden = true;

      if (resultTitle) resultTitle.textContent = winner.title;
      if (resultCopy) resultCopy.textContent = `${winner.collection}. ${winner.copy}`;
      if (resultTop) resultTop.textContent = selectedTop(winnerKey, winner);
      if (resultBottom) resultBottom.textContent = selectedBottom(winner);
      if (resultAccessory) resultAccessory.textContent = selectedAccessory(winner.accessories);
      setResultImage(resultTopImage, selectedTopImage(winnerKey, winner), selectedTop(winnerKey, winner));
      setResultImage(resultBottomImage, selectedBottomImage(winner), selectedBottom(winner));
      setResultImage(resultAccessoryImage, selectedAccessoryImage(winner), selectedAccessory(winner.accessories));
      if (resultReasons) {
        resultReasons.innerHTML = "";
        const reasons = buildReasons();
        if (!reasons.length) reasons.push("Matched from your product and movement preferences");
        reasons.forEach((reason) => {
          const item = document.createElement("li");
          item.textContent = reason;
          resultReasons.appendChild(item);
        });
      }
      if (resultPanel) updateImage(resultPanel.getAttribute("data-image"));
      updateStory("Your ZODA set", winner.title, winner.copy);
      if (resultPanel) resultPanel.classList.add("is-active");
      if (resultLink) {
        resultLink.textContent = "Choose size and color";
      }
      if (shopLink) shopLink.href = state.resultUrl || "/collections/all";
      trackEvent("zoda_quiz_completed", {
        quiz_result: winnerKey,
        gender: state.answers.gender || "",
        training: state.answers.training || "",
        accessory: state.answers.accessory || ""
      });
    }

    root.addEventListener("click", (event) => {
      const answer = event.target.closest("[data-zoda-quiz-answer]");
      if (!answer || answer.hidden) return;
      const activeStep = currentStep();
      if (!activeStep || !activeStep.contains(answer)) return;

      const key = currentStepKey();
      state.answers[key] = answer.getAttribute("data-value") || "";
      state.selections.set(key, answer);
      trackEvent("zoda_quiz_step_answered", {
        step: key,
        answer: state.answers[key],
        step_index: state.activeIndex + 1
      });

      if (key === "gender") {
        state.selections.forEach((selected, selectedKey) => {
          if (selectedKey !== "gender") state.selections.delete(selectedKey);
        });
        Object.keys(state.answers).forEach((answerKey) => {
          if (answerKey !== "gender") delete state.answers[answerKey];
        });
      }

      activeStep.querySelectorAll("[data-zoda-quiz-answer]").forEach((button) => {
        button.classList.toggle("is-selected", button === answer);
      });
      if (nextButton) nextButton.disabled = false;
    });

    if (resultLink) {
      resultLink.addEventListener("click", (event) => {
        event.preventDefault();
        openVariantModal();
      });
    }

    if (variantClose) variantClose.addEventListener("click", closeVariantModal);
    if (variantModal) {
      variantModal.addEventListener("click", (event) => {
        if (event.target === variantModal) closeVariantModal();
      });
    }
    if (addSetButton) addSetButton.addEventListener("click", addSelectedSet);
    root.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && variantModal && !variantModal.hidden) closeVariantModal();
    });

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        if (!state.selections.get(currentStepKey())) return;
        const steps = activeSteps();
        if (state.activeIndex >= steps.length - 1) {
          showResult();
          return;
        }
        state.activeIndex += 1;
        render();
      });
    }

    if (backButton) {
      backButton.addEventListener("click", () => {
        if (state.activeIndex === 0) return;
        state.activeIndex -= 1;
        render();
      });
    }

    restartButtons.forEach((button) => {
      button.addEventListener("click", () => {
        state.activeIndex = 0;
        state.answers = {};
        state.resultUrl = "/collections/all";
        state.winnerKey = "";
        state.winner = null;
        state.modalItems = [];
        state.selections.clear();
        if (nextButton) nextButton.hidden = false;
        if (controls) controls.hidden = false;
        render();
      });
    });

    if (form) {
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        const email = emailInput && emailInput.value ? emailInput.value.trim() : "";
        if (!email) return;
        form.classList.add("is-submitted");
        const note = form.querySelector("[data-zoda-quiz-email-note]");
        if (note) note.textContent = "Saved for handoff. Connect this to Shopify Forms, Klaviyo or the dashboard API next.";
      });
    }

    decorateAnswerIcons();
    render();
  });
})();
